import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, switchMap, withLatestFrom } from 'rxjs';
import { MessageService } from '@letly/ui-common';
import { ToastSeverity } from '@letly/models';
import { LandlordListingService } from './landlord-listing.service';
import { landlordListingActions } from './landlord-listing.actions';
import { Store } from '@ngrx/store';
import { selectPageNumber } from './landlord-listing.selectors';

@Injectable()
export class LandlordListingEffect {

  private actions$ = inject(Actions);
  private propertyListService = inject(LandlordListingService);
  private messageService = inject(MessageService);
  private store = inject(Store);


  private loadProperties$ = createEffect(() =>
    this.actions$.pipe(
      ofType(landlordListingActions.load),
      withLatestFrom(this.store.select(selectPageNumber)),
      switchMap(([action, currentPage]) => {
          const page = action.append ? currentPage + 1 : 1;
          return this.propertyListService.getProperties(page, action.status).pipe(
            map(r => {
              if (r.success) {
                return landlordListingActions.loaded({
                  status: 'success',
                  items: r.data.items,
                  totalNumberOfItems: r.data.totalNumberOfItems,
                  pageNumber: r.data.pageNumber,
                  pageSize: r.data.pageSize,
                  message: '',
                  hasMore: r.data.hasMore,
                  append: action.append ?? false
                });
              }
              this.messageService.showSnackbar(r.niceErrorMessage, ToastSeverity.Error);
              return landlordListingActions.loaded({
                status: 'error',
                message: r.niceErrorMessage,
                items: null,
                pageSize: null,
                pageNumber: null,
                hasMore: false,
                totalNumberOfItems: null,
                append: action.append ?? false
              });
            })
          );
        }
      )
    )
  );

}
